import type { ChecklistTeam } from '~/types/checklist'

import { TEAM_NAME_MAPPING } from '~/const'

export const getTeamNameMapping = (key: ChecklistTeam): string => {
  return TEAM_NAME_MAPPING[key] || 'Unknown'
}
